import { Observable } from '../../Observable';
import { _if } from '../../observable/if';

Observable.if = _if;


// WEBPACK FOOTER //
// ../../../src/add/observable/if.ts